'use client';

import { c as _c } from "react/compiler-runtime";
import { Configure, InstantSearch } from 'react-instantsearch';
import { liteClient as algoliasearch } from 'algoliasearch/lite';
import Box from '@mui/material/Box';
import NoSsr from '@mui/material/NoSsr';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import { usePathname, useSearchParams } from 'src/routes/hooks';
import { CONFIG } from 'src/global-config';
import { useTranslate } from 'src/locales';
import { Iconify } from 'src/components/iconify';
import { ProductAutocomplete } from './product-autocomplete';

// ----------------------------------------------------------------------

const {
  appId,
  apiKey
} = CONFIG.algolia;
const searchClient = algoliasearch(appId, apiKey);
const getSellerID = pathnameParts => pathnameParts[1] === 'profile' ? pathnameParts[2] : '';
export function ProductSearch(t0) {
  const $ = _c(35);
  const {
    seller,
    sx
  } = t0;
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const {
    t,
    currentLang
  } = useTranslate();
  let filters;
  let query;
  if ($[0] !== currentLang || $[1] !== pathname || $[2] !== searchParams || $[3] !== seller?.id) {
    filters = ["publish:\"YES\""];
    let t1;
    if ($[6] !== searchParams) {
      t1 = searchParams.get("query") ?? "";
      $[6] = searchParams;
      $[7] = t1;
    } else {
      t1 = $[7];
    }
    query = t1;
    const country = searchParams.get("country") ?? currentLang.countryName;
    const sellerID = seller?.id ?? searchParams.get("sellerID") ?? getSellerID(pathname.split("/"));
    if (country) {
      filters.push(`country:"${country}"`);
    }
    if (sellerID) {
      filters.push(`sellerID:"${sellerID}"`);
    }
    $[0] = currentLang;
    $[1] = pathname;
    $[2] = searchParams;
    $[3] = seller?.id;
    $[4] = filters;
    $[5] = query;
  } else {
    filters = $[4];
    query = $[5];
  }
  let t1;
  if ($[8] !== query || $[9] !== t) {
    t1 = () => <TextField size="small" defaultValue={query} placeholder={`${t("Search products, brands and more")}...`} slotProps={{
      input: {
        startAdornment: <InputAdornment position="start"><Iconify icon="eva:search-fill" sx={{
            color: "text.disabled"
          }} /></InputAdornment>,
        sx: {
          borderRadius: {
            xs: 1,
            md: 2.5
          },
          height: {
            xs: 45,
            md: "initial"
          },
          backgroundColor: "background.paper"
        }
      }
    }} />;
    $[8] = query;
    $[9] = t;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  const renderFallback = t1;
  let t2;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      width: 1
    };
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== sx) {
    t3 = Array.isArray(sx) ? sx : [sx];
    $[12] = sx;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== t3) {
    t4 = [t2, ...t3];
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== renderFallback) {
    t5 = renderFallback();
    $[16] = renderFallback;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      preserveSharedStateOnUnmount: true
    };
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== query) {
    t7 = {
      search_promotions: {
        query
      }
    };
    $[19] = query;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  const t8 = filters.join(" AND ");
  let t9;
  if ($[21] !== t8) {
    t9 = <Configure filters={t8} />;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== query) {
    t10 = <ProductAutocomplete initialQuery={query} />;
    $[23] = query;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t7 || $[27] !== t9) {
    t11 = <InstantSearch searchClient={searchClient} indexName="search_promotions" future={t6} initialUiState={t7}>{t9}{t10}</InstantSearch>;
    $[25] = t10;
    $[26] = t7;
    $[27] = t9;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t11 || $[30] !== t5) {
    t12 = <NoSsr fallback={t5}>{t11}</NoSsr>;
    $[29] = t11;
    $[30] = t5;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== t12 || $[33] !== t4) {
    t13 = <Box className="stack" sx={t4}>{t12}</Box>;
    $[32] = t12;
    $[33] = t4;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  return t13;
}